export default __webpack_public_path__ + "static/media/main.6d196f03.jpeg";